import React from "react";
import { Routes, Route, Outlet, Link } from "react-router-dom";
import Header from "./components/Layout/Header";
import Base from "./Base";
import Home from "./components/Pages/PaymentGateway/Home/Home";
import GetStarted from "./components/Pages/PaymentGateway/GetStarted/GetStarted";
import Dashboard from "./components/Pages/PaymentGateway/Dashboard/Dashboard";
import PaymentModesAvailable from "./components/Pages/PaymentGateway/PaymentModesAvailable/PaymentModesAvailable";
import Settlements from "./components/Pages/PaymentGateway/Settlements/Settlements";
import Refunds from "./components/Pages/PaymentGateway/Refunds/Refunds";
import PaymentLinks from "./components/Pages/PaymentGateway/PaymentLinks/PaymentLinks";
import PaymentButton from "./components/Pages/PaymentGateway/PaymentButton/PaymentButton";
import QRCodes from "./components/Pages/PaymentGateway/QRCodes/QRCodes";
import SmartCollect from "./components/Pages/PaymentGateway/SmartCollect/SmartCollect";
import RedirectCheckoutPlugins from "./components/Pages/PaymentGateway/RedirectCheckoutPlugins/RedirectCheckoutPlugins";
import PaymentIntegration from "./components/Pages/PaymentGateway/PaymentIntegration/PaymentIntegration";
import JSCheckout from "./components/Pages/PaymentGateway/JSCheckout/JSCheckout";
import ECollectAPI from "./components/Pages/PaymentGateway/ECollectAPI/ECollectAPI";
import ValidateVPAAPI from "./components/Pages/PaymentGateway/ValidateVPAAPI/ValidateVPAAPI";
import StatusAPI from "./components/Pages/PaymentGateway/StatusAPI/StatusAPI";
import RefundAPI from "./components/Pages/PaymentGateway/RefundAPI/RefundAPI";
import ResellerAPI from "./components/Pages/PaymentGateway/ResellerAPI/ResellerAPI";
import TransactionMIS from "./components/Pages/PaymentGateway/TransactionMIS/TransactionMIS";
import SettlementMISAPI from "./components/Pages/PaymentGateway/SettlementMISAPI/SettlementMISAPI";
import Webhook from "./components/Pages/PaymentGateway/Webhook/Webhook";
import IntegrationAPIforMerchantOnboarding from "./components/Pages/PaymentGateway/IntegrationAPIforMerchantOnboarding/IntegrationAPIforMerchantOnboarding";

import Invoices from "./components/Pages/PaymentGateway/Invoices/Invoices";
import TestAndLiveMode from "./components/Pages/TestAndLiveMode";
import Reports from "./components/Pages/Reports";
// import Overview from "./components/Pages/Introduction";
import Introduction from "./components/Pages/Introduction";

// import Introduction from "./components/Pages/NeoBanking/Introduction/Introduction";
import Usecases from "./components/Pages/NeoBanking/Usecases/Usecases";
import FeaturesAndFunctions from "./components/Pages/NeoBanking/FeaturesAndFunctions/FeaturesAndFunctions";
import AvailablePayModes from "./components/Pages/NeoBanking/AvailablePayModes/AvailablePayModes";
import PayoutLifecycleandState from "./components/Pages/NeoBanking/PayoutLifecycleandState/PayoutLifecycleandState";
import PayoutSolution from "./components/Pages/NeoBanking/PayoutSolution/PayoutSolution";
import AddFundstoVA from "./components/Pages/NeoBanking/AddFundstoVA/AddFundstoVA";
import SafexpayPayoutErrorCodes from "./components/Pages/NeoBanking/SafexpayPayoutErrorCodes/SafexpayPayoutErrorCodes";

import HowtodoPayout from "./components/Pages/NeoBanking/HowtodoPayout/HowtodoPayout";

import Page404 from "./components/Layout/Page404";

import SettlementMISAPI_Temp from "./components/Pages/PaymentGateway/SettlementMISAPI/SettlementMISAPI";
import Enviroments from "./components/Pages/PaymentGateway/Environments/Environments";
import ProcessFlowIntegrationMethods from "./components/Pages/PaymentGateway/ProcessFlow-IntegrationMethods/ProcessFlowIntegrationMethods";
import AggHostedNonSeamless from "./components/Pages/PaymentGateway/ProcessFlow-IntegrationMethods/AggHostedNonSeamless";
import MerchantHostedSeamless from "./components/Pages/PaymentGateway/ProcessFlow-IntegrationMethods/MerchantHostedSeamless";
import AggregatorHostedwithPaymode from "./components/Pages/PaymentGateway/ProcessFlow-IntegrationMethods/AggregatorHostedwithPaymode";
import JSCheckOutInternational from "./components/Pages/PaymentGateway/ProcessFlow-IntegrationMethods/JSCheckOutInternational";
import APIIntegration from "./components/Pages/PaymentGateway/ProcessFlow-IntegrationMethods/APIIntegration";
import IntegrationwithSafexPay from "./components/Pages/PaymentGateway/IntegrationWithSafexPay/IntegrationwithSafexPay";
import StatusAPIPg from "./components/Pages/PaymentGateway/StatusApiPg/StatusAPIPg";
import MovingtoLives from "./components/Pages/PaymentGateway/MovingtoLIVE/MovingtoLives";
import RefundsAPI from "./components/Pages/PaymentGateway/RefundAPI_NW/RefundsAPI";
import WebhookAPI from "./components/Pages/PaymentGateway/WebhookAPI_NW/WebhookAPI";
import FAQs from "./components/Pages/PaymentGateway/FAQs/FAQs";
import OurSupport from "./components/Pages/PaymentGateway/SupportTeams/OurSupport";
import TransactionResponseCodes from "./components/Pages/PaymentGateway/TransactionResponseCodes/TransactionResponseCodes";
import RefundsProcessing from "./components/Pages/PaymentGateway/RefundsProcessingThroughDashboard/RefundsProcessing";
import GooglePay from "./components/Pages/PaymentGateway/Wallets/GooglePay";
import SamsungPay from "./components/Pages/PaymentGateway/Wallets/SamsungPay";
import ApplePay from "./components/Pages/PaymentGateway/Wallets/ApplePay";
import Linkbasedapi from "./components/Pages/PaymentGateway/LinkBasedAPI/Linkbasedapi";
import VoidApi from "./components/Pages/PaymentGateway/VoidAPI/VoidApi";
// import SettlementMISAPI_Temp from './components/Pages/SettlementMISAPI/SettlementMISAPI';
function RoutesCom() {
  return (
    <Base>
      <Routes>
        <Route path="/" element={<Introduction />} />
        {/* <Route path="/GetStarted" element={<GetStarted />} /> */}
        {/* <Route path="/dashboard" element={<Dashboard />} /> */}
        {/* <Route
          path="/PaymentModesAvailable"
          element={<PaymentModesAvailable />} /> */}

        {/* <Route path="/Settlements" element={<Settlements />} /> */}
        {/* <Route path="/Refunds" element={<Refunds />} /> */}
        {/* <Route path="/PaymentLinks" element={<PaymentLinks />} /> */}
        {/* <Route path="/PaymentButton" element={<PaymentButton />} /> */}
        {/* <Route path="/Invoices" element={<Invoices />} /> */}
        {/* <Route path="/QRCodes" element={<QRCodes />} /> */}
        {/* <Route path="/SmartCollect" element={<SmartCollect />} /> */}
        <Route
          path="/RedirectCheckoutPlugins"
          element={<RedirectCheckoutPlugins />}
        />
        {/* <Route path="/PaymentIntegration" element={<PaymentIntegration />} /> */}
        {/* <Route path="/JSCheckout" element={<JSCheckout />} /> */}
        {/* <Route path="/ECollectAPI" element={<ECollectAPI />} /> */}
        {/* <Route path="/ValidateVPAAPI" element={<ValidateVPAAPI />} /> */}
        {/* <Route path="/StatusAPI" element={<StatusAPI />} /> */}
        {/* <Route path="/RefundAPI" element={<RefundAPI />} /> */}
        {/* <Route path="/ResellerAPI" element={<ResellerAPI />} /> */}
        {/* <Route path="/TransactionMIS" element={<TransactionMIS />} /> */}
        {/* <Route path="/SettlementMISAPI" element={<SettlementMISAPI />} /> */}
        {/* <Route path="/Webhook" element={<Webhook />} /> */}
        {/* <Route
          path="/IntegrationAPIforMerchantOnboarding"
          element={<IntegrationAPIforMerchantOnboarding />}
        /> */}

        {/* <Route path="/test-and-live-mode" element={<TestAndLiveMode />} /> */}
        {/* <Route path="/Reports" element={<Reports />} /> */}

        <Route path="/Introduction" element={<Introduction />} />
        <Route path="/Enviroments" element={<Enviroments />} />
        <Route
          path="/ProcessFlowIntegrationMethods"
          element={<ProcessFlowIntegrationMethods />}
        />

        <Route
          path="/AggHostedNonSeamless"
          element={<AggHostedNonSeamless />}
        />
        <Route
          path="/MerchantHostedSeamless"
          element={<MerchantHostedSeamless />}
        />
        <Route
          path="/AggregatorHostedwithPaymode"
          element={<AggregatorHostedwithPaymode />}
        />
        <Route
          path="/JSCheckOutInternational"
          element={<JSCheckOutInternational />}
        />
        <Route path="/APIIntegration" element={<APIIntegration />} />
        <Route
          path="/IntegrationwithSafexPay"
          element={<IntegrationwithSafexPay />}
        />
        <Route path="/StatusAPIPg" element={<StatusAPIPg />} />
        <Route path="/MovingtoLives" element={<MovingtoLives />} />
        <Route path="/RefundsAPI" element={<RefundsAPI />} />
        <Route path="/WebhookAPI" element={<WebhookAPI />} />
        <Route path="/FAQs" element={<FAQs />} />
        {/* <Route path="/OurSupport" element={<OurSupport />} /> */}
        <Route
          path="/TransactionResponseCodes"
          element={<TransactionResponseCodes />}
        />
        <Route path="/RefundsProcessing" element={<RefundsProcessing />} />
        <Route path="/GooglePay" element={<GooglePay />} />
        <Route path="/SamsungPay" element={<SamsungPay />} />
        <Route path="/ApplePay" element={<ApplePay />} />
        <Route path="/Linkbasedapi" element={<Linkbasedapi />} />
        <Route path="/VoidApi" element={<VoidApi />} />

        {/* 
                <Route path="/Introduction" element={<Introduction />} />
                <Route path="/Usecases" element={<Usecases />} />
                <Route path="/FeaturesAndFunctions" element={<FeaturesAndFunctions />} />
                <Route path="/AvailablePayModes" element={<AvailablePayModes />} />
                <Route path="/PayoutLifecycleandState" element={<PayoutLifecycleandState />} />
                <Route path="/PayoutSolution" element={<PayoutSolution />} />
                <Route path="/tempmis" element={<SettlementMISAPI_Temp />} />
                <Route path="/AddFundstoVA" element={<AddFundstoVA />} />
                <Route path="/SafexpayPayoutErrorCodes" element={<SafexpayPayoutErrorCodes />} />
                <Route path="/HowtodoPayout" element={<HowtodoPayout />} /> */}

        <Route path="*" element={<Page404 />} />
      </Routes>
    </Base>
  );
}

export default RoutesCom;
